<template>
  <div class="lp-base" :class="`lp-base--${lpId}`">
    <component
      :is="targetComp"
      :lp-id="lpId"
      :target-info="targetInformation"
      :color-scheme="targetColorScheme"
      :token="token"
    />
    <lp-footer :color-scheme="targetColorScheme" :menu-list="footerMenuList" :lp-id="lpId" />
  </div>
</template>

<script>
import * as type from '@/utvStore/store/mutation-types'
import { BASIC_DATA, DEFAULT_FOOTER_MENULIST } from './commons'
import DetailView from '@/utvStore/components/partials/DetailView'
import LpFooter from './blocks/LpFooter'
import BasicInputKurenotori from './counselor/kurenotori/BasicInput'
import BasicInputKanoucoco from './counselor/kanoucoco/BasicInput'
import BasicInputTouwa from './counselor/touwa/BasicInput'
import BasicInputHouen from './counselor/houen/BasicInput'
import BasicInputOttimo from './counselor/ottimo/BasicInput'
import BasicInputSomarimone from './counselor/somarimone/BasicInput'

export default {
  name: 'RecommendBasicInputManager',
  components: {DetailView, LpFooter},
  props: {
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    lpId: {
      type: Number,
      default: 1,
    },
    token:{
      type: String,
      default: '',
    }
  },
  computed: {
    footerMenuList(){
      return [
        { label: `${this.targetInformation.name}TOP`, url: `/recommend/lp/${this.lpId}` },
        ...DEFAULT_FOOTER_MENULIST,
      ]
    },
    targetColorScheme(){
      switch (this.lpId) {
        case 1: return BASIC_DATA.kurenotori.colorScheme
        case 2: return BASIC_DATA.kanoucoco.colorScheme
        case 3: return BASIC_DATA.touwa.colorScheme
        case 4: return BASIC_DATA.houen.colorScheme
        case 5: return BASIC_DATA.ottimo.colorScheme
        case 6: return BASIC_DATA.somarimone.colorScheme
      }
    },
    targetInformation(){
      switch (this.lpId) {
        case 1: return BASIC_DATA.kurenotori.information
        case 2: return BASIC_DATA.kanoucoco.information
        case 3: return BASIC_DATA.touwa.information
        case 4: return BASIC_DATA.houen.information
        case 5: return BASIC_DATA.ottimo.information
        case 6: return BASIC_DATA.somarimone.information
      }
    },
    targetComp(){
      switch (this.lpId) {
        case 1: return BasicInputKurenotori
        case 2: return BasicInputKanoucoco
        case 3: return BasicInputTouwa
        case 4: return BasicInputHouen
        case 5: return BasicInputOttimo
        case 6: return BasicInputSomarimone
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.targetColorScheme)
  },
  mounted(){},
  methods: {},
}</script>

<style scoped lang="scss">
//LP内 各ブロックの基本設定
/deep/ .basic-block {
  width: 100%;
  max-width: 580px;
  // background: #fcc;
  margin: 0 auto;
  // padding: 16px;
  // border-bottom: 1px solid #bbb;
  position: relative;
  z-index: 1;
  .content-wrap {
    width: 100%;
    position: relative;
    z-index: 100;
  }

  h1,h2,h3,h4,h5,h6{
    // margin: 0 0 16px;
  }
}
.lp-base {
  &--3 {
    /deep/ .lp-footer {
      background: #9C8961;
    }
  }
}
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/RecommendBasicInputManager.vue